var NumberHelper = /** @class */ (function () {
    function NumberHelper() {
    }
    NumberHelper.ceil = function (value, precisions) {
        if (precisions === void 0) { precisions = 0; }
        if (0 === precisions) {
            return Math.ceil(value);
        }
        return Math.ceil(value * Math.pow(10, precisions)) / Math.pow(10, precisions);
    };
    return NumberHelper;
}());
export default NumberHelper;
